"use client";

import React from "react";
import PageLayout from "@/layouts/pageLayout";
import Introduction from "./components/introduction";
import CloudManagement from "./components/cloudManagement";

const CloudApplicationPage = () => {
  return (
    <PageLayout marginTop={12} showContactForm showCustomers spacing={16}>
      <Introduction />
      <CloudManagement />
    </PageLayout>
  );
};

export default CloudApplicationPage;
